import moment from "moment";

export const INITIAL_STATE = {
  customerId: "HCF0999",
  applicationId: "",
  cardioVascular:"N",
  careInd:"N",
  verbiage:"",
  pdfBlobs:[],
  loginEmailId: "",
  productId: "",
  groupId: "",
  pbpId: "",
  planId: "",
  electionType: "",
  prefix: "",
  firstName: "",
  lastName: "",
  suffix: "",
  middleInitial: "",
  birthDate: "",
  sex: "",
  primaryPhoneNum: "",
  cellPhoneNum: "",
  streetAddress: "",
  permanentAddrApt: "",
  permanentAddress: {
    streetAddress: "",
    city: "",
    county: "",
    state: "",
    zipCode: "",
  },
  mailingAddress: {
    streetAddress: "",
    city: "",
    county: "",
    state: "",
    zipCode: "",
  },
  permanentAddrStreet:"",
  permanentCounty: "",
  permanentCity: "",
  permanentState: "",
  permanentZip: "",
  mailingAddressRequired: "",
  mailingAddr: "",
  mailingCity: "",
  mailingState: "",
  mailingzip: "",
  mailingCounty:"",
  mailingCountyCd:"",
  emailAddress: "",
  emailOptionIndicator: "",
  termsAndConditions:"",
  callAlert: "",
  //medicareClaim: "",
  medicareNumber: "",
  partAEffDate: "",
  partBEffDate: "",
  paymentOption: "D",
  acctholdername: "",
  bankname: "",
  acctType: "",
  routingNumber: "",
  accountNumber: "",
  monthlybf: "",
  renalDisease: "",
  esrdcontact: "",
  //vaBenefits: "",
  isDrugCoverage: "",
  //nameOfCov: "",
  nameOfCoverage: "",
  //idOfCov: "",
  covMemberNumber: "",
  //groupOfCov: "",
  covGroupNumber: "",
  medicaidprg: "",
  medicaidNbr: "",
  prescriptionDrug: "",
  nameOfInst: "",
  phoneOfInst: "",
  doYouWork:"",
  esrdInd:"",
  medicaidInd:"",
  premiumType:"",
  monthlybenefitsfrom:"",
  medicaidId:"",
  addrOfInst: "",
  isSpouseWork: "",
  pcpName: "",
  pcpMedicalGroupName: "",
  isCurrentPatient: "",
  ethnicityRace:[],
  spanish: "",
  accessibleFormatVal: "",
  languageCheckSpanish: "",
  languageCheckOther: "",
  aep: "",
  c1: "",
  c2: "",
  attestation2: "",
  permanentZip4:"",
  mailingZip4:"",
  authZip4:"",
  questionDate:"",
  c3: "",
  attestation3: "",
  c4: "",
  attestation4: "",
  c5: "",
  attestation5: "",
  c6: "",
  c7: "",
  c8: "",
  attestation8: "",
  c9: "",
  attestation9: "",
  c10: "",
  attestation10: "",
  c11: "",
  attestation11: "",
  c12: "",
  attestation12: "",
  c13: "",
  c14: "",
  c15: "",
  attestation15: "",
  c16: "",
  c16Attestation: "",
  attestation16: "",
  recentlyChangeMedicaid: "",
  attestation7: "",
  coveragebegin: "",
  name: "",
  digitalSignature: "",
  todayDate: moment().format("MM/DD/YYYY"),
  //authorizedrepname: "",
  nameOfRep: "",
  lastNameOfRep:"",
  authRepCity:"",
  authRepState:"",
  authRepZip:"",
  applcat:"",
  //authorizedreprelationship: "",
  relationOfRep: "",
  //authorizedrepaddress: "",
  addressOfRep: "",
  phoneNumberOfRep: "",
  salRepName: "",
  salRepLicenseNumber: "",
  ltcInd:"",
  addrOfInstitution:"",
  nameOfInstitution:"",
  //ssn:"",
  //effDate: "",
  proposedEffDate: "",
  retiree: "",
  retiredate: "",
  retirename: "",
  meddependsp: "",
  dependentSpouse: "",
  dependentOther: "",
  hlthcovType: "",
  hlthcovInscomp: "",
  c20: "",
  c21: "",
  attestation21: "",
  c22: "",
  attestation22: "",
  c23: "",
  attestation23: "",
  c24: "",
  attestation24: "",
  c25: "",
  attestation25: "",
  Socialnumber: "",
  planYear: "",
  coveringSpouseOrDependent: "",
  coveringSpouseOrDependentLastName: "",
  coveringSpouseOrDependentFirstName: "",
  coveringSpouseOrDependentMiddleName: "",
  coveringSpouseOrDependentEmployeeName: "",
  survivingSpouseCitySanDiegoRetiree: "",
  survivingSpouseCitySanDiegoRetireeLastName: "",
  survivingSpouseCitySanDiegoRetireeFirstName: "",
  survivingSpouseCitySanDiegoRetireeMiddleName: "",
  //authorizedRep: "",
  isAuthRepresentative: "",
  isLicensedSalesRep: "",
  mailingZip: "",
  c_qns1: "",
  state: "CA",
  clinicName: "",
  createUserDetails: "",
  isEligible: "",
  isUpdated: false,

  //file upload
  soa: "",
  agentSign: "",
  medCard: "",
  idInf: "",
  misc: "",

  // Step2 Medi Sup
  companyName: "",
  quesStartDate: "",
  quesStartDate2: "",
  quesEndDate: "",
  quesEndDate2: "",
  enrollGrp: "Wipro Prime Health Medigap Plan (F)",
  enrollProd: "Medicare Supplement",
  enrollSource: "B",
  PremAmt: "",
  pwoOptions: "",
  partCeffDate: "",
  partBeffDate: "",
  partAeffDate: "",
  sepReasonCd: "",
  agentTaxId:"",
  agentEmail:"",
  enrlDate:"",
};

export const INITIAL_STATE1 = {
  applicationType: "",
  operatorID: "",
  applicatioStatus: "",
  currentStatus: "",
  ApplID: "",
  reqDateCovg: "",
  prefix: "",
  firstName: "",
  lastName: "",
  middleName: "",
  suffix: "",
  birthdate: "",
  applicationNo: "",
  supplementalId: "",
  mbrID: "",
  Socialnumber: "",
  gender: "",
  medicareId: "",
  hicNo: "",
  xrefClaimNumber: "",
  lastchecked: "",
  address3: "",
  address2: "",
  address1: "",
  city: "",
  state: "",
  zip: "",
  county: "",
  fax: "",
  cellPhone: "",
  workPhone: "",
  email: "",
  homePhone: "",
  mailAddress1: "",
  mailAddress2: "",
  mailAddress3: "",
  mailCounty: "",
  mailState: "",
  mailcity: "",
  mailZip: "",
  mailFirstName: "",
  mailMiddleName: "",
  mailSuffix: "",
  mailLastName: "",
  enrollGrp: "",
  enrollProd: "",
  enrollSource: "",
  PremAmt: "",
  language: "",
  pwoOptions: "",
  partCeffDate: "",
  partBeffDate: "",
  partAeffDate: "",
  companyName: "",
  quesStartDate: "",
};

export const PROSPECT_MANAGEMENT_INITIAL_STATE = {
  firstName: "",
  lastName: "",
  mbi: "",
  dob: "",
  gender: "",
  preferredLang: "",
  planCampaignName: "",
  permissionToContact: "",
  planType: "",
  statusType: "",
  assignedTo: "",
  eligibleForPartA: "",
  eligibleForPartB: "",
  eligibleForPartD: "",
  middleInitial: "",
  leadIdNbr: "",
  customerId: "",
  beneRepSignature: "",
  salesChannelOth:"",
  beneRepSignDate: "",
  relationshipToBene: "",
  repName: "",
  isAuthRep:"",
  beneBirthDate:"",
  productName: "",
  agentName: "",
  agentPhone: "",
  agentSign: "",
  appointmentDateComp: "",
  agentSignDate:"",
  beneName: "",
  benePhone: "",
  beneAddress: "",
  initialMethodOfContact: "",
  captureBeneRepSign: "NO",
  CaptureAgentSignature: "YES",
  primaryAddress1: "",
  primaryAddress2: "",
  city: "",
  state: "",
  zip: "",
  zipPlus4: "",
  county: "",
  contactPreference: [],
  emailAddress: "",
  homePhone: "",
  cellPhone: "",
  bestTimeToCall: [],
  medicaidId:"",
  planYear:new Date().getFullYear().toString()
};
export const CAMPAIGN_MANAGEMENT_INITIAL_STATE={
  associatedProduct:"",
  campaignEndDate:"",
  campaignMedia:"",
  campaignOwner:"",
  campaignOwnerId:"",
 campaignStartDate:"",
 campaignStatus:"",
 contactPreference:"",
  planCampaignId:"",
 planCampaignName:""
}
export const PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE = {
  contactName: "",
  lastName: "",
  relation: "",
  comment: "",
  addNewComment: "",
  dateOfCall:"",
};
